import React, {Component} from 'react';
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";
import {chartColors} from "../../../../../../../../../../Utils/ChartUtils/chartColors";
import _ from "lodash";
import ScreenDesignerListHoc from "../../../../../../../../../../HocHelpers/ScreenDesignerListHoc";
import {ChartTitle} from "../../../../../../../../../../Utils/ChartUtils/ChartTitle";
import {
    findColor, getColumnById,
    getColumnTypeById,
    humanizeDuration, renderCustomizedLabel,
    transformData
} from "../../../../../../../../../../Utils/ChartUtils/chartUtils";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import FilterListIcon from '@material-ui/icons/FilterList';
import formatValue from "../../../../../../../../../../Utils/ListUtils/FormatValue";

class PieRechart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            columns: [],
            props: {
                valueColumn: '',
                labelColumn: '',
                legend: {}
            }
        };
    }

    componentDidMount() {
        const {
            columns, chartProps,
            data: {content = []} = {},
            pivotData = [],
            pivotGeneratedColumns = []
        } = this.props;
        let currentData = pivotData.length > 0 ? pivotData : content;
        let currentColumns = pivotGeneratedColumns.length > 0 ? pivotGeneratedColumns : columns;
        let data = transformData(currentData, currentColumns);

        this.setState({
            props: chartProps,
            columns: currentColumns,
            listData: data,
        });
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            columns, chartProps,
            data: {content} = {},
            pivotData = [],
            pivotGeneratedColumns = []
        } = this.props;
        const {
            chartProps: prevChartProps, columns: prevColumns = {},
            data: {content: prevContent},
            pivotData: prevPivotData = [], pivotGeneratedColumns: prevPivotGeneratedColumns = []
        } = prevProps;

        let currentData = pivotData.length > 0 ? pivotData : content;
        let currentColumns = pivotGeneratedColumns.length > 0 ? pivotGeneratedColumns : columns;
        let prevCurrentColumns = prevPivotGeneratedColumns.length > 0 ? prevPivotGeneratedColumns : prevColumns;
        let prevCurrentData = prevPivotData.length > 0 ? prevPivotData : prevContent;

        if (currentData !== prevCurrentData) {
            let data = transformData(currentData, currentColumns);
            this.setState({
                columns: currentColumns,
                listData: data,
            })
        }
        if (currentColumns !== prevCurrentColumns) {
            this.setState({
                columns: currentColumns
            })
        }

        if (!_.isEmpty(chartProps) && chartProps !== prevChartProps) {
            this.setState({props: chartProps})
        }
    }

    render() {
        const {
            listData,
            columns,
            props: {
                series = [],
                valueColumn = '',
                labelColumn = '',
                enableRadialLabels = true,
                showNameInLabel,
                legend: {
                    enable: legendEnable,
                    position: legendPosition,
                    verticalAlign,
                    direction,
                    itemHeight,
                    itemWidth,
                    translateY,
                    translateX
                }
            }
        } = this.state;
        const {
            label,
            chartProps: {
                showAdvancedFilter,
                hideTitle,
                title: {
                    styles: {
                        fontSize: {size, type} = {},
                        fontStyle,
                        fontWeight,
                        textDecoration,
                        textAlign,
                        color,
                        background: titleBackground
                    } = {}
                } = {}
            }
        } = this.props;
        return (
            <>
                <div style={{display: 'flex'}}>
                    <div style={{flexGrow: 1}}>
                <ChartTitle
                    hideLabel={hideTitle}
                    size={size}
                    type={type}
                    fontWeight={fontWeight}
                    fontStyle={fontStyle}
                    textDecoration={textDecoration}
                    textAlign={textAlign}
                    title={label}
                    color={color}
                    background={titleBackground}
                />
                    </div>
                    {showAdvancedFilter && (
                        <IconButton style={{padding: 2}} disabled>
                            <Icon style={{margin: 5}}>
                                <FilterListIcon/>
                            </Icon>
                        </IconButton>
                    )}
                </div>
                <ResponsiveContainer>
                    <PieChart
                        margin={{
                            top: 50, right: 30, left: 30, bottom: 57,
                        }}
                    >
                        <Tooltip
                            labelFormatter={(value) => {
                                const columnType = getColumnTypeById(columns, valueColumn);
                                const columnFormat = getColumnById(columns, valueColumn).format;
                                return columnType === 'duration' ?
                                    humanizeDuration(value, columnFormat) :
                                    formatValue(value, columnType, columnFormat)
                            }}
                            formatter={(value) => {
                                const columnType = getColumnTypeById(columns, valueColumn);
                                const columnFormat = getColumnById(columns, valueColumn).format;
                                return columnType === 'duration' ?
                                    humanizeDuration(value, columnFormat) :
                                    formatValue(value, columnType, columnFormat)
                            }}
                        />
                        <Pie
                            data={listData.filter(v => {return v[valueColumn] !== undefined})}
                            dataKey={valueColumn}
                            nameKey={labelColumn}
                            outerRadius={'85%'}
                            innerRadius={'50%'}
                            fill="#8884d8"
                            label={enableRadialLabels ? (v) => renderCustomizedLabel(v, columns, valueColumn, showNameInLabel) : false}
                            animationDuration={300}
                        >
                            {
                                listData.map((entry, index) => {
                                    const customColor = findColor(series, entry[labelColumn]);
                                    return (
                                        <Cell key={`cell-${index}`}
                                              fill={customColor ? customColor : chartColors[index % chartColors.length]}/>
                                    )
                                })
                            }
                        </Pie>
                        {legendEnable && (
                            <Legend
                                align={legendPosition}
                                verticalAlign={verticalAlign}
                                layout={direction}
                                height={parseInt(itemHeight)}
                                width={parseInt(itemWidth)}
                                wrapperStyle={{
                                    paddingLeft: translateX ? `${translateX}px` : 0,
                                    paddingTop: translateY ? `${translateY}px` : 0
                                }}
                            />
                        )}
                    </PieChart>
                </ResponsiveContainer>
            </>
        );
    }
}

export default ScreenDesignerListHoc(PieRechart)